import React, { createContext, useState, useContext, forwardRef } from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Slide from "@mui/material/Slide";

const SnackbarContext = createContext();

export const useSnackbar = () => useContext(SnackbarContext);

const SnackbarTransition = forwardRef(function SnackbarTransition(props, ref) {
  const { in: inProp, ...other } = props;

  return (
    <Slide
      ref={ref}
      {...other}
      in={inProp}
      direction={inProp ? "left" : "down"}
      timeout={{
        enter: 300,
        exit: 300,
      }}
    />
  );
});


const SnackbarProvider = ({ children }) => {
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const showSnackbar = (message, severity = "info") => {
    setSnackbarState({
      open: true,
      message,
      severity,
    });
  };

  const closeSnackbar = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  return (
    <SnackbarContext.Provider value={showSnackbar}>
      {children}

      <Snackbar
        open={snackbarState.open}
        autoHideDuration={4000}
        onClose={closeSnackbar}
        TransitionComponent={SnackbarTransition}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MuiAlert
          onClose={closeSnackbar}
          severity={snackbarState.severity}
          elevation={6}
          sx={{
            width: "100%",
            borderRadius: 2,
          }}>
          {snackbarState.message}
        </MuiAlert>
      </Snackbar>
    </SnackbarContext.Provider>
  );
};

export default SnackbarProvider;
